export default __webpack_public_path__ + "static/media/video_square_section2.4b0bec48.mp4";